import React from "react";

interface Props {
  className?: string;
}

export const ClarissaDavid: React.FC<Props> = ({ className = "" }) => {
  return (
    <img
      src="/img/testimonials/clarissa-david-circle-1.svg"
      alt="Clarissa and David"
      className={`w-[500px] h-[500px] object-cover ${className}`}
    />
  );
}; 